import React from "react";
import { Link } from "react-router-dom";

const cols = [
  {
    title: "Résiliation Express",
    items: [
      { to: "/a-propos", label: "À propos" },
      { to: "/comment-ca-marche", label: "Comment ça marche" },
      { to: "/faq", label: "FAQ" },
      { to: "/contact", label: "Contact" },
    ],
  },
  {
    title: "Services",
    items: [
      { to: "/annuaire", label: "Annuaire" },
      { to: "/annuaire", label: "Rechercher un organisme" },
      { to: "/resilier", label: "Commencer une résiliation" },
      { to: "/espace", label: "Suivre mon dossier" },
      { to: "/blog", label: "Blog & conseils" },
      { to: "/modeles-lettres", label: "Modèles de lettres" },
    ],
  },
  {
    title: "Professionnels",
    items: [
      { to: "/courtiers", label: "Espace courtier" },
      { to: "/courtiers", label: "Devenir partenaire" },
      { to: "/tarifs", label: "Tarifs" },
    ],
  },
  {
    title: "Informations légales",
    items: [
      { to: "/mentions-legales", label: "Mentions légales" },
      { to: "/cgu", label: "CGU" },
      { to: "/cgv", label: "CGV" },
      { to: "/politique-confidentialite", label: "Politique de confidentialité" },
      { to: "/cookies", label: "Politique de cookies" },
      { to: "/reclamation", label: "Réclamations" },
      { to: "/mentions-legales#mediateur", label: "Médiateur de la consommation" },
    ],
  },
];

export default function Footer() {
  const openCookiePrefs = () => {
    // Broadcast a global event that CookieConsent listens to
    try { window.dispatchEvent(new CustomEvent("re:open-cookie-preferences")); }
    catch (e) { /* older browsers fallback */ }
  };

  return (
    <footer className="border-t border-border bg-secondary/30 mt-16" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          <div className="col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="h-8 w-8 rounded-lg bg-gradient-brand flex items-center justify-center">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path d="M4 8L12 3L20 8V16L12 21L4 16V8Z" stroke="white" strokeWidth="2" strokeLinejoin="round"/>
                </svg>
              </div>
              <span className="font-semibold">Résiliation Express</span>
            </div>
            <p className="text-sm text-muted-foreground max-w-xs leading-relaxed">
              Résiliation Express est un service indépendant d'accompagnement administratif. Ni compagnie d'assurance,
              ni organisme public, ni représentant des entreprises référencées.
            </p>
            <p className="text-xs text-muted-foreground mt-3 font-mono">
              SASU · SIREN 107 406 878 · RCS Paris
            </p>
          </div>
          {cols.map((c) => (
            <div key={c.title}>
              <h4 className="text-xs uppercase tracking-widest font-semibold mb-4 text-foreground">{c.title}</h4>
              <ul className="space-y-2">
                {c.items.map((i, idx) => (
                  <li key={`${c.title}-${i.to}-${idx}`}>
                    <Link
                      to={i.to}
                      className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-200"
                      data-testid={`footer-link-${c.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}-${idx}`}
                    >
                      {i.label}
                    </Link>
                  </li>
                ))}
                {c.title === "Informations légales" && (
                  <li>
                    <button
                      type="button"
                      onClick={openCookiePrefs}
                      className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-200 text-left"
                      data-testid="footer-open-cookies-btn"
                    >
                      Gérer mes cookies
                    </button>
                  </li>
                )}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 pt-8 border-t border-border flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <p className="text-xs text-muted-foreground">
            © {new Date().getFullYear()} Résiliation Express (SASU) · Tous droits réservés.
          </p>
          <p className="text-xs text-muted-foreground font-mono">
            Made in France · Legaltech
          </p>
        </div>
      </div>
    </footer>
  );
}
